<div class="sidebar-wrapper d-flex flex-column h-100">
    <div class="client-sidebar text-primary-green border h-100  rounded-lg d-flex flex-column shadow p-2 bg-white">
        <button
          class="btn btn-close d-lg-none align-self-end m-2 d-none"
          @click="$emit('close')"
          aria-label="Close sidebar"></button>
        <div class="sidebar-brand text-center mt-3">
          <a class="mt-3" id="sidebar_toggle">
            <img :src="$clientLogo" alt="Logo" class="logo-img" width="160px">
          </a>
          <hr class="mx-2 mt-4"/>
        </div>
        
        <div class="sidebar-content flex-grow-1 scrollable-container">
          <div class="d-flex justify-content-center  h-100">
            <!-- Workflows Dynamic Sidebar -->
            <ul class="nav flex-column h-100">
              <!-- User Management Sidebar-->
              <template  v-if="should_show_template">
                <nav  class="entity-sidebar">
                  <ul class="nav flex-column">
                    <li>
                      <router-link to="/user_management" class="nav-item nav-link text-decoration-none" active-class="active">
                        <i class="fas fa-users"></i> Users
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/roles_management" class="nav-item nav-link  text-decoration-none" active-class="active">
                        <i class="fas fa-user-shield"></i> Roles
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/creating_a_policy" class="nav-item nav-link text-decoration-none" active-class="active">
                        <i class="fas fa-key"></i> Policy
                      </router-link>
                    </li>
                    <li >
                      <router-link to="/action_management" class="nav-item nav-link text-decoration-none" active-class="active">
                        <i class="fa-solid fa-screwdriver-wrench"></i> Actions
                      </router-link>
                    </li>
                    <!-- System Configuration -->
                    <li class="">
                      <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#systemConfigMenu" role="button" aria-expanded="false" aria-controls="systemConfigMenu">
                        <span><i class='fa-solid fa-gear me-1'></i> System Configuration </span>
                        <i class="bx bxs-chevrons-down rotate-icon"></i>
                      </a>
                      <ul class="collapse list-unstyled ps-3" id="systemConfigMenu">
                        <li>
                          <router-link to="/manage_entity_type" class="nav-item nav-link text-decoration-none" active-class="active">
                            <i class='bx bxs-chevrons-right text-primary'></i> Entity Type
                          </router-link>
                        </li>
                        <li v-if="is_super_user">
                          <router-link to="/verification_services_configurations" class="nav-item nav-link text-decoration-none" active-class="active">
                            <i class='bx bxs-chevrons-right text-primary'></i>Verification Services
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/form_management" class="nav-item nav-link text-decoration-none" active-class="active">
                            <i class='bx bxs-chevrons-right text-primary'></i>Manage Forms
                          </router-link>
                        </li>
                        <li>
                        <router-link to="/data_points" class="nav-item nav-link text-decoration-none d-none" active-class="active">
                          <i class='bx bxs-chevrons-right text-primary'></i>Manage Data Points
                        </router-link>
                      </li>
                        <li>
                          <router-link to="/manage_questions" class="nav-item nav-link text-decoration-none" active-class="active">
                            <i class='bx bxs-chevrons-right text-primary'></i> Manage Questions
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/view_template" class="nav-item nav-link text-decoration-none" active-class="active">
                            <i class='bx bxs-chevrons-right text-primary'></i>Manage Templates
                          </router-link>
                        </li>
                          <li>
                          <router-link to="/signing_workflow" class="nav-item nav-link text-decoration-none" active-class="active">
                            <i class='bx bxs-chevrons-right text-primary'></i>Manage Signing
                          </router-link>
                        </li>

                        <li>
                        <router-link to="/status_management" class="nav-item nav-link text-decoration-none" active-class="active">
                          <i class='bx bxs-chevrons-right text-primary'></i>Manage Statuses
                        </router-link>
                      </li>
                      
                        <li>
                          <router-link to="/create_enquiry_form" class="nav-item nav-link text-decoration-none" active-class="active">
                            <i class='bx bxs-chevrons-right text-primary'></i>Enquiries
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/services" class="nav-item nav-link text-decoration-none" active-class="active">
                            <i class='bx bxs-chevrons-right text-primary'></i>Services
                          </router-link>
                      </li>
                        <li>
                          <router-link to="/package_services" class="nav-item nav-link text-decoration-none" active-class="active">
                            <i class='bx bxs-chevrons-right text-primary'></i>Packages
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/create_enquiry_stages" class="nav-item nav-link text-decoration-none" active-class="active">
                            <i class='bx bxs-chevrons-right text-primary'></i>CRM Configurations
                          </router-link>
                        </li>
                        <li>
                        <router-link to="/manage_risks" class="nav-item nav-link text-decoration-none" active-class="active">
                          <i class='bx bxs-chevrons-right text-primary'></i>Manage Risks
                        </router-link>
                      </li>
                        
                    </ul>
                    </li>
                  </ul>
                </nav>
              </template>
              <!-- Entity Sidebar -->
              <div v-else-if="['/view_user_trust_form', '/view_all_user_forms', '/requested_information_update', '/unresolved_request', '/resolved_requests', '/enquiry_chat', '/entity_application_overview', '/application_overview_details', '/auto_verification_overview', '/entity_overview', '/view_contracts', '/entity_risk_assessment', '/answer_risk_assessment', '/lead_questionnaire', '/lead_questionnaire_form', '/entity_enquiry_management', '/proof_of_payments'].includes($route.path)">
                <nav v-if="sorted_menu_items?.length" class="entity-sidebar">
                  <ul class="nav flex-column">
                    <template v-for="component in sorted_menu_items" :key="component.id">
                      <li v-for="sub in component.sub_components" :key="sub.id">
                        <!-- If no child components -->
                        <router-link
                          v-if="!sub.child_components?.length"
                          :to="build_route_location(sub, component)"
                          class="nav-item nav-link text-decoration-none"
                          active-class="active"
                        >
                          {{ sub.name }}
                        </router-link>

                        <!-- If has child components -->
                        <a
                          v-else
                          class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center"
                          data-bs-toggle="collapse"
                          :href="'#collapse-' + sub.id"
                          role="button"
                          aria-expanded="false"
                          :aria-controls="'collapse-' + sub.id"
                        >
                          <span>{{ sub.name }}</span>
                          <i class="bx bxs-chevrons-down rotate-icon"></i>
                        </a>

                        <!-- Nested child components -->
                        <ul
                          v-if="sub.child_components?.length"
                          class="ms-4 collapse list-unstyled ps-3"
                          :id="'collapse-' + sub.id"
                        >
                          <li v-for="child in sub.child_components" :key="child.id">
                            <router-link
                              :to="build_route_location(child, sub)"
                              class="nav-item nav-link text-decoration-none d-flex align-items-center"
                              :class="{ active: is_item_active(child, sub) }"
                            >
                              <i v-if="child.icon_class" :class="child.icon_class" class="me-1 fs-6"></i>
                              {{ child.name }}
                            </router-link>
                          </li>
                        </ul>
                      </li>
                    </template>
                  </ul>
                </nav>
              </div>
              <!-- Main Sidebar -->
              <div v-else>
                <template v-if="sorted_menu_items?.length">
                  <nav class="entity-sidebar">
                    <ul class="nav flex-column" v-for="component in sorted_menu_items" :key="component.id">
                      <li v-for="sub in component.sub_components" :key="sub.id">
                        <!-- Single router-link for items without children -->
                        <router-link
                          v-if="!sub.child_components?.length"
                          :to="build_route_location(sub, component)"
                          class="nav-item nav-link text-decoration-none "
                          active-class="active">
                          <i v-if="sub.icon_class" :class="sub.icon_class" class="me-1 fs-6"></i> <span class="sidebar-text" :title="sub.name">{{ sub.name }}</span>
                        </router-link>

                        <!-- Collapsible section for items with children -->
                        <template v-else>
                          <a
                            class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center"
                            data-bs-toggle="collapse"
                            :href="'#collapse-' + sub.id"
                            role="button"
                            aria-expanded="false"
                            :aria-controls="'collapse-' + sub.id"
                            :class="{ active: is_status_active(sub.url) }">
                            <span><i v-if="sub.icon_class" :class="sub.icon_class" class="me-1 fs-6"></i>
                              <span class="sidebar-text" :title="sub.name">{{ sub.name }}</span>
                            </span>
                            <i class="bx bxs-chevrons-down rotate-icon"></i>
                          </a>
                          <ul
                            class="ms-4 collapse list-unstyled"
                            :id="'collapse-' + sub.id">
                            <li v-for="child in sub.child_components" :key="child.id">
                              <router-link
                                :to="build_route_location(child, sub, true)"
                                class="nav-item nav-link text-decoration-none"
                                :class="{ active: is_item_active(child, sub) }">
                                <i class='bx bxs-chevrons-right text-primary'></i> 
                                <span class="sidebar-text" :title="child.name">{{ child.name }}</span>

                              </router-link>
                            </li>
                          </ul>
                        </template>
                      </li>
                    </ul>
                  </nav>
                </template>
              </div>
            </ul>
        </div>
    </div>
  </div>
</div>